import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { stoneBiome } from '../biomeArchetypes';
import { ATMOSPHERE_PALETTE as P } from '../palette';

/** Dungeon (temple / coil / crypt) — dim dusty shafts, torch motes, a warm light bed, torch
 *  flicker, low fog, and a distant temple-column silhouette. */
export const DUNGEON = stoneBiome({
  id: 'dungeon',
  sky: { from: 0x0a0806, to: 0x33241a },
  motes: { colors: [P.torch, P.bone], count: 12, sizeMin: 8, sizeMax: 16, driftPx: 18, periodMinMs: 9000, periodMaxMs: 18000, alphaMin: 0.15, alphaMax: 0.5 },
  rays: { color: P.bone, count: 3, widthMin: 50, widthMax: 120, height: 480, tiltDeg: 10, periodMinMs: 11000, periodMaxMs: 20000, alphaMin: 0.1, alphaMax: 0.35 },
  glow: {
    blobs: [{ color: P.torch, atX: 0.5, atY: 0.92, size: 460, alpha: 0.08 }],
    breathe: { periodMs: 5400, min: 0.7, max: 1.3, phase: 0.15 },
  },
  lightField: { palette: [P.torch, P.bone, P.amber], count: 10, sizeMin: 80, sizeMax: 180, alphaMin: 0.04, alphaMax: 0.13, driftRadius: 30, periodMinMs: 11000, periodMaxMs: 20000 },
  flicker: { color: P.torch, size: 180, baseAlpha: 0.18, flickerAmp: 0.1, hzMin: 4, hzMax: 9, anchors: [{ atX: 0.15, atY: 0.55 }, { atX: 0.85, atY: 0.55 }, { atX: 0.5, atY: 0.5 }] },
  // Dungeon fog sits BEFORE the parallax (the haze hangs between the viewer and
  // the colonnade depth) — placed in extraLayers so it precedes the parallax block.
  extraLayers: [
    { kind: 'fog', color: P.bone, bands: 4, alphaMin: 0.04, alphaMax: 0.12, driftPx: 50, periodMinMs: 15000, periodMaxMs: 25000 },
  ],
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.ruins.far, shape: 'columns', color: 0x2a2018, speed: 0.04, height: 440, alpha: 0.7, detail: 0.8, sway: { ampPx: 8, periodMs: 34000 } },
    { svg: OTHERWORLD_BACKDROPS.ruins.mid, shape: 'columns', color: 0x1c150f, speed: 0.10, height: 320, alpha: 0.84, detail: 1 },
    { svg: OTHERWORLD_BACKDROPS.ruins.near, shape: 'columns', color: 0x100b08, speed: 0.18, height: 220, alpha: 0.94, detail: 1.1 },
  ],
  closer: {
    vignette: { color: 0x000000, edgeAlpha: 0.4 },
    grade: { top: 0x2a3550, bottom: 0x0a0c14, strength: 0.16, blend: 'normal' },
  },
});
